module.exports = __webpack_public_path__ + "img/prop-cloud.0dbe6218.webp";